export default "__VITE_ASSET__O6M1U0Ly__"